export default "/images/vendor/flag-icon-css/flags/1x1/fm.svg?12e9e2f28f79474f8cae1102cd8c092b";